import { AiCoach_ChatSessionStatus as ChatSessionStatus } from '__generated__/graphql-types';

import type { SessionActions, SetChatState } from 'bundles/ai-course-coach/store/actions/types';
import type { SessionState } from 'bundles/ai-course-coach/store/types';
import { createReducer } from 'bundles/ai-course-coach/utils/createReducer';

import {
  CLEAR_CHAT_SESSION,
  NEW_CHAT_SESSION,
  SET_CHAT_SESSION_ID,
  SET_CHAT_SESSION_STORAGE_KEY,
  SET_CHAT_STATE,
} from '../actions/types';

const initialState: SessionState = {
  chatSessionId: undefined,
  chatSessionStorageKey: undefined,
  chatState: ChatSessionStatus.Active,
};
// @ts-disable
// @eslint-disable
const sessionStateReducer = {
  [NEW_CHAT_SESSION]: (state: SessionState) => {
    return {
      ...state,
      chatSessionId: undefined,
      chatSessionStorageKey: undefined,
    };
  },
  [CLEAR_CHAT_SESSION]: (state: SessionState) => ({
    ...state,
    chatSessionId: undefined,
    chatSessionStorageKey: undefined,
  }),
  [SET_CHAT_SESSION_ID]: (state: SessionState, { chatSessionId }: SessionState) => ({
    ...state,
    chatSessionId,
  }),

  [SET_CHAT_SESSION_STORAGE_KEY]: (state: SessionState, chatSessionStorageKey: string) => ({
    ...state,
    chatSessionStorageKey,
  }),
  // @ts-enable
  // @eslint-enable
  [SET_CHAT_STATE]: (state: SessionState, actionArgs: SetChatState): SessionState => ({
    ...state,
    chatState: actionArgs.chatState,
  }),
};
export default (state = initialState, action: SessionActions) => createReducer(sessionStateReducer, state, action);
